import { ISearchFilters, ISearchType } from "./SearchPage";
import FilesList from "../../components/blocks/TerracedGridTheme/FilesFoldersBlock/FilesList";
import { Dispatch, SetStateAction } from "react";
import { ResultsHOC } from "./ResultsHOC";
import {
  IReactiveFileContentItem,
  IReactiveFolderContentItem,
} from "../../components/schoolfeed/SchoolFeedContentItem";
import { isSchoolBlocksApp } from "../../utils/SchoolBlocksUtilities";
import { ExpandYourSearchInfoBox } from "./PageSearchResults";
import { PaginationFooter } from "./PaginationFooter";
import { useStores } from "../../stores/useStores";

export function FilesAndFoldersResults(props: {
  searchTypes: ISearchType[];
  setSearchTypes: Dispatch<SetStateAction<ISearchType[]>>;
  results: {
    google_drive?: {
      data: Array<IReactiveFileContentItem | IReactiveFolderContentItem>;
      meta: {
        total: number;
      };
    };
    files_and_folders?: {
      data: Array<IReactiveFileContentItem | IReactiveFolderContentItem>;
      meta: {
        total: number;
      };
    };
  };
  isValidating: boolean;
  searchTerm: string;
  setFilters: Dispatch<SetStateAction<ISearchFilters>>;
  filters: ISearchFilters;
}) {
  const { organizationStore } = useStores();
  const isSchoolBlocks = isSchoolBlocksApp();
  const googleDriveResults = props.searchTypes.includes("google_drive");
  const dataset = googleDriveResults
    ? props.results?.google_drive
    : props.results?.files_and_folders;
  const data = dataset?.data || [];
  const total = dataset?.meta?.total || 0;
  const pageSize = googleDriveResults
    ? props.filters["google_drive.page_size"]
    : props.filters["files_and_folders.page_size"];
  const page = googleDriveResults
    ? props.filters["google_drive.page"]
    : props.filters["files_and_folders.page"];
  const totalFilesFolderPages = Math.ceil(total / pageSize);

  const shouldSearchGoogleDrive =
    organizationStore.organization.json_data?.settings?.identity?.provider ===
      "google" &&
    organizationStore.organization.json_data.settings.identity.google
      .searchDrive &&
    isSchoolBlocks;

  const onClick = () => {
    props.searchTypes.includes("google_drive")
      ? props.setSearchTypes((v) => v.filter((t) => t !== "google_drive"))
      : props.setSearchTypes((v) => ["google_drive", ...v]);
  };

  const buttonText = props.searchTypes.includes("google_drive")
    ? "Search site files"
    : "Search Google Drive";

  const googleDriveOption = shouldSearchGoogleDrive && (
    <div style={{ marginBottom: 5 }}>
      <ExpandYourSearchInfoBox
        onClick={onClick}
        buttonText={buttonText}
        searchType={"files_and_folders"}
      />
    </div>
  );

  return (
    <ResultsHOC
      isLoading={props.results?.files_and_folders === undefined}
      isValidating={props.isValidating}
      resultsCount={total}
      searchTypes={props.searchTypes}
      thisComponentType={
        googleDriveResults ? "google_drive" : "files_and_folders"
      }
      searchTerm={props.searchTerm}
      noResultsString={"documents"}
      noResultsOptions={googleDriveOption}
    >
      {googleDriveOption}
      <FilesList files_folders={data} aboveTheFold={true} />
      <PaginationFooter
        currentPage={page}
        setPage={(page) =>
          props.setFilters((v) => ({
            ...v,
            [googleDriveResults
              ? "google_drive.page"
              : "files_and_folders.page"]: page,
          }))
        }
        totalPages={totalFilesFolderPages}
      />
    </ResultsHOC>
  );
}
